import { ChangeDetectionStrategy, Component, OnInit, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';

import { PageSlotModule } from '@spartacus/storefront';

import { ITeaser, SdTeaserComponent } from '@seb/web-design-system/teaser';
import { SdIconComponent } from '@seb/web-design-system/core';

import { AbstractPageComponent } from '../../templates/abstract-page/abstract-page.component';
import { HeadingParagraphMapper } from '../../mappers';

@Component({
  selector: 'wc-empty-page',
  templateUrl: './empty-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    PageSlotModule,
    SdIconComponent,
    SdTeaserComponent
  ]
})
export class EmptyPageComponent extends AbstractPageComponent implements OnInit {
  dataTeaser = signal<ITeaser[]>([]);
  isStatic = signal(false);

  constructor(
    private headingParagraphMapper: HeadingParagraphMapper,
    private translateService: TranslateService,
    private route: ActivatedRoute
  ) {
    super();

    this.eagerLoadingSlot = 'FreeZone';
    this.eagerLoadingLimit = 1;
  }

  ngOnInit(): void {
    super.ngOnInit();

    if (this.route.snapshot.url[0]?.path === 'error') {
      const errorCode = this.route.snapshot.paramMap.get('code') ?? '';
      this.isStatic.set(true);

      this.dataTeaser.set([{
        content: {
          heading: this.headingParagraphMapper.toHeadingParagraph({
            heading: {
              description: this.translateService.instant(`httpErrors.${errorCode}`),
              headline: errorCode
            }
          })
        },
        media: {
          url: '/assets/images/error.jpg',
          mime: ''
        }
      }]);
    }
  }
}
